export enum UserDesk {
    Primary,
    Secondary,
}

export const UserDeskLabels = {
    [UserDesk.Primary]: 'Primary',
    [UserDesk.Secondary]: 'Secondary',
}
